import { GatewayEntreprise } from "@conformite/gateway";
import { axiosInstance } from "@src/data/utils/axiosInstance";

export class GatewayEntrepriseApi {
  static async getEntrepriseById(
    defaultMillesime: number,
    entrepriseId: string
  ): Promise<GatewayEntreprise.EntrepriseAControllerResponseType> {
    const response =
      await axiosInstance.get<GatewayEntreprise.EntrepriseAControllerResponseType>(
        `${GatewayEntreprise.entrepriseControllerUrl}/admin/${defaultMillesime}/${entrepriseId}`
      );
    return response.data;
  }
}
